import { z } from 'zod';
import { FlowProducedType } from '../../../flowRun/producedType.js';
import { BaseFlowBlockSchema, FlowBlockReturnTypeSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
export var FlowProviderIdType;
(function (FlowProviderIdType) {
    FlowProviderIdType["USER_ID"] = "USER_ID";
    FlowProviderIdType["EHR_PROVIDER_INFORMATION_ID"] = "EHR_PROVIDER_INFORMATION_ID";
})(FlowProviderIdType || (FlowProviderIdType = {}));
export const FlowGetProviderBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.GetProvider),
    returnType: FlowBlockReturnTypeSchema(FlowProducedType.Provider),
    config: z
        .object({
        providerIdType: z.enum(FlowProviderIdType).optional(),
        providerId: z.string().optional(),
    })
        .refine((data) => (data.providerId ? data.providerIdType !== undefined : true), {
        message: 'Provider id type is required if provider id is specified',
        path: ['providerIdType'],
    }),
});
//# sourceMappingURL=config.js.map